import { render, staticRenderFns } from "./EditBild.vue?vue&type=template&id=700a983a"
import script from "./EditBild.vue?vue&type=script&lang=ts"
export * from "./EditBild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports